module.exports = __webpack_public_path__ + "img/earth_secure.e86b5aaf.png";